var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sui-toast" },
    [
      _c(
        "sui-popup",
        {
          attrs: {
            "has-mask": true,
            "transparent-mask": true,
            "close-on-click-mask": false,
            value: _vm.value
          },
          on: {
            input: function($event) {
              return _vm.$emit("input", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "sui-toast-wrapper",
              class: {
                "sui-toast-wrapper--icon": _vm.iconType || _vm.$slots.icon,
                "sui-toast-wrapper--loose": _vm.loose
              }
            },
            [
              _vm.iconType || _vm.$slots.icon
                ? _c(
                    "div",
                    {
                      staticClass: "sui-toast-icon",
                      class: {
                        "sui-toast-icon--only": !_vm.$slots.default && !_vm.text
                      }
                    },
                    [
                      _vm._t("icon", [
                        _c("sui-icon", {
                          attrs: {
                            size: "28px",
                            color: "#fff",
                            type: _vm.iconType
                          }
                        })
                      ])
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default", [_vm._v(_vm._s(_vm.text))])
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }